import { useResetExperiences } from '@cascade/react/experiences';
import * as conversations from '@cascade/react-dom/conversations';
import type { PropsWithChildren } from 'react';
import { CONVERSATION_PATH, HOME_PATH } from '#config/index.ts';
import { llmHttp, llmSocket } from './Conversations.clients.ts';

export const ConversationsProvider = ({ children }: PropsWithChildren) => {
  const resetExperiences = useResetExperiences();

  return (
    <conversations.ConversationsProvider
      socket={llmSocket}
      http={llmHttp}
      conversationPath={`/${CONVERSATION_PATH}`}
      homePath={HOME_PATH}
      onConversationsDeleted={resetExperiences}
    >
      {children}
    </conversations.ConversationsProvider>
  );
};
